import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Divider, Grid2 } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import QRCode from 'react-qr-code';
import {Mysection, MydivCOM,MydivRUP,Myrow,cardDownload,sanitizetel,initials,capitalize,openURL,EneaButton,parseToLink } from './Style';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Avatar} from '@mui/material';
import {Chip, Stack,Box,Tab,Tabs} from '@mui/material';
import { Fragment, useEffect } from 'react';
import { AvvisoCard } from './AvvisoCard';
import { blue, green,red} from '@mui/material/colors';
import { useState,useMemo } from 'react';
import { type } from '@testing-library/user-event/dist/type';

const cols=(obj)=>{
    return {
        id:obj.id,
        garaid:obj.gara_id,
        link:obj.link_scheda_gara,
        lottoid:obj.lotto_id,
        oggapp:obj.oggetto_appalto,
        dtinizio:obj.dt_inizio,
        chiusura:obj.dt_fine,

    }
}

const EsitiCard = ({handleclose,detailurl,detail,showclose})=>{
    //console.log("detail are: "+JSON.stringify(detail));

    const [showlotto, setLotto] = useState();
    const [showgara, setGara] = useState();
    //const [detail, setDetails] = useState();

    // fetch(detailurl)
    //     .then(r => r.json())
    //     .then(j => {
    //         //setBusy(false);
    //         if (j.length > 0) {
    //             setDetails(j[0]);
    //         } else {
    //             console.log("too much elements " + j);
    //         }
    //     }
    //     ).catch(err => { console.log("err")})
    
    useEffect(() => {
        if (detail !== undefined) {
            //const detail = JSON.parse(strdetail);
            console.log("detail: " + JSON.stringify(detail));
            if (detail.gare.length > 0)
                setGara(detail.gare[0].id);
            if (detail.lotti.length > 0)
                setLotto(detail.lotti[0].gara_lotto_id);
            // setDetails(detail);
        }
        return null;   
    },[detail]);

    const handleChangeLotto = (event, newValue) => {
        setLotto(newValue);
    };
    
    const handleChangeGara = (event, newValue) => {
        setGara(newValue);
    };

    const cardGara = useMemo(()=>{
        if(showgara!==undefined){
            const o = detail.gare.filter( obj => obj.id===showgara).pop();
            // console.log("avvisi: " + JSON.stringify(o.avvisi));
            // console.log("avvisi is: " + typeof o.avvisi);
            return (
            <Grid2 key={uuidv4()} >
                <Card >
                    <Myrow name="id gara" val={o.id}/>
                    <Myrow name="oggetto appalto" val={o.oggetto_appalto}/>
                    <Myrow name="scadenza offerta" val={o.scadenza_offerta}/>
                    <Myrow name="importo base asta" val={new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(o.importo_base_asta)||'-'}/>
                    <Myrow name="note" val={o.note}/>
                    <Myrow name="procedura nome" val={o.procedura_nome}/>
                    <Myrow name="criterio nome" val={o.criterio_nome}/>
                    <Myrow name="pubblicazione giornalistica" val={o.pubblicazione_giornalistica}/>
                    <Myrow name="pubblicazione giuridica" val={o.pubblicazione_giuridica}/>
                    <Stack direction="row" spacing={5} sx={{p:2}} alignItems="center"> 
                    <p>Dati RUP</p><MydivRUP obj={o}/>
                    </Stack>
                    <Divider/>
                    <Stack direction="row" spacing={5} sx={{p:2}} alignItems="center">
                    <p>Commissione</p><MydivCOM obj={o}/>
                    </Stack>
                    <Divider/>
                        <Myrow name="UO richiedente" val={o.uo_richiedente} />
                        {o.avvisi.map(p=>{
                            return (
                                <AvvisoCard
                                    key={uuidv4()}
                                    detail={p}
                                    handleclose={() => console.log(false)}
                                />
                            );
                        })}
                        
                    {/* <Myrow name="avvisi gare" val={typeof o.avvisi === "string" ? o.avvisi : JSON.stringify(o.avvisi)}/> */}
                <CardContent>
                <Grid2 container spacing={4} rowGap={2}>
                {o.allegati.map(p=>{
                    return (
                    <Grid2>
                        <Card>
                            <Typography variant="h6" component="div">
                                    {p.tag}
                            </Typography>
                            <CardContent>
                                {cardDownload(p)}
                            </CardContent>
                        </Card>
                    </Grid2>);
                })}
                </Grid2>
                </CardContent>
            </Card>
            </Grid2>);
        }
    },[showgara,detail])

    const cardLotto = useMemo(()=>{
        if(showlotto!==undefined){
            const o = detail.lotti.filter( obj => obj.gara_lotto_id===showlotto).pop();
            return (
                <Grid2 key={uuidv4()}>
                        <Card>
                            <Chip label={"lotto "+o.gara_lotto_id}/>
                            <Myrow name="id" val={o.id}/>
                            <Myrow name="oggetto" val={o.oggetto_appalto}/>
                            <Myrow name="CIG" val={o.CIG}/>
                            <Stack direction="row" spacing={2} sx={{p:2}} alignItems="center">
                            <p>BDNCP</p><a href={"https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig="+o.CIG} title="vai alla pagina">
                                <Typography variant="h5" component="span">
                                <OpenInNewIcon/>{"https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig="+o.CIG}
                                    </Typography></a>
                            </Stack>
                            <Divider/>
                            <Myrow name="importo netto" val={new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(o.importo_base)||'-'}/>
                            <Myrow name="scadenza offerta" val={o.scadenza_selezione}/>
                            <Myrow name="seduta pubblica aggiudicazione" val={o.seduta_pubblica_aggiudicazione}/>
                            <Myrow name="luogo seduta aggiudicazione" val={o.luogo_seduta_aggiudicazione}/>
                            <Myrow name="durata contratto" val={o.durata_contratto+" "+o.misura_contratto}/>
                            <Myrow name="note" val={o.note}/>
                            
                        <CardContent>
                        <Grid2 container spacing={4} rowGap={2}>
                        {o.allegati.map(p=>{
                            return (
                            <Grid2>
                                <Card>
                                    <Typography variant="h6" component="div">
                                            {p.tag}
                                    </Typography>
                                    <CardContent>
                                        {cardDownload(p)}
                                    </CardContent>
                                </Card>
                            </Grid2>);
                        })}
                        </Grid2>
                        </CardContent>
                        </Card>
                    </Grid2>
                );
        }
    },[showlotto,detail])

    
/*
<div>
                        <Avatar alt={detail.RUP_nome}>{initials(detail.RUP_nome)}</Avatar>
                        <Typography variant="h5" component="p">
                            {capitalize(detail.RUP_nome)}
                        </Typography>
                        <p>email: <Typography variant="h6" component="span">
                            <a title="invia mail" href={"mailto:"+detail.RUP_email}>
                                {detail.RUP_email}
                            </a></Typography></p>
                        <p>PEC: <Typography variant="h6" component="span">
                        <a title="invia mail" href={"mailto:"+detail.RUP_pec}>
                            {detail.RUP_pec||"-"}</a></Typography></p>
                        <p>telefono: <Typography variant="h6" component="span">{sanitizetel(detail.RUP_tel)}</Typography></p>
                        <p>fax: <Typography variant="h6" component="span">{sanitizetel(detail.RUP_fax)}</Typography></p>
                    </div>
*/
/*
<CardMedia
                component="img"
                className="cardimg"
                alt="ENEA"
                href="https://www.enea.it"
                onClick={()=>window.location.href="https://www.enea.it"}
                sx={{display:"inline",width:140,height:40}}
                image="https://www.enea.it/images/layout/logoenea1.png"
            />*/

            /*<Grid2>
                <Typography variant="h5" component="div">
                    ID {detail.id}
                </Typography>
                </Grid2>
                */


            /*<p>Importo Netto Aggiudicazione : <Typography variant="h6" component="span">{ new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(detail.importo_aggiudicazione)||'-'}</Typography></p>
                    <p>Procedura di Scelta Contraente : <Typography variant="h6" component="span">{detail.procedura_nome||'-'}</Typography></p>
                    <p>Criterio di Aggiudicazione : <Typography variant="h6" component="span">{detail.criterio_nome||'-'}</Typography></p>
                    <p>Lotto : <Typography variant="h6" component="span">{(detail.lotto_id<0)?"-":detail.lotto_id}</Typography></p>
                    <p>Note :</p>
                    <Typography variant="h6" component="span" sx={{ textWrap:"balance"}}>
                        {detail.note}
                    </Typography>
                    */

            /*
            <p>Data Inizio Attività (Verbale/Ordine) : <Typography variant="h6" component="span">{new Date(detail.dt_inizio).toLocaleDateString()||'-'}</Typography></p>
                    <p>Data chiusura esito : <Typography variant="h6" component="span">{(detail.data_chiusura_esito===null)?"-":new Date(detail.data_chiusura_esito).toLocaleDateString()}</Typography></p>
                    <p>Data Fine Attività (Collaudo/Fornitura) : <Typography variant="h6" component="span">{new Date(detail.dt_fine).toLocaleDateString()||'-'}</Typography></p>
                    <p>UO richiedente : <Typography variant="h6" component="span">{detail.uo_richiedente}</Typography></p>
                    **/

    return (
        <Card>
            <CardContent>
                <Mysection text="sintesi" />
                <Grid2 container alignItems='center' spacing={{ xs: 0, md: 2 }} columns={{ xs: 4, sm: 4, md: 8, xl: 12 }} rowGap={3} >
                    <Grid2 size={3} paddingLeft='5%' alignSelf='center'>
                        <Button variant='text'
                            aria-label={"CIG " + detail.CIG}
                            title='vai al sito ANAC'
                            onClick={() => openURL("https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig=" + detail.CIG)}>
                            <Fragment>
                                <Stack
                                    alignItems='center'
                                    divider={<Divider flexItem />}
                                    spacing={3}
                                    useFlexGap
                                    sx={{ flexWrap: 'wrap' }}
                                >
                                    <Typography variant="h5" component="div" sx={{ paddingRight: 1 }}>
                                        <OpenInNewIcon />CIG {detail.CIG}
                                    </Typography>
                                    <QRCode
                                        title={"CIG " + detail.CIG}
                                        size={128}
                                        onClick={() => openURL("https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig=" + detail.CIG)}
                                        style={{ height: "auto", minWidth: "30%", maxWidth: "50%" }}
                                        value={"https://dati.anticorruzione.it/superset/dashboard/dettaglio_cig/?cig=" + detail.CIG}
                                        viewBox={`0 0 128 128`}
                                    />
                                </Stack>
                            </Fragment>
                        </Button>

                    </Grid2>
                    <Grid2 size={4}>
                        <p>Dati Responsabile Procedimento :</p>
                        <MydivRUP obj={detail} />
                    </Grid2>

                    <Grid2 size={4}>
                        <Myrow name="Importo Netto Aggiudicazione :" val={new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(detail.importo_aggiudicazione) || '-'} />
                        <Myrow name="Procedura di Scelta Contraente :" val={detail.procedura_nome || '-'} />
                        <Myrow name="Criterio di Aggiudicazione :" val={detail.criterio_nome || '-'} />
                        <Myrow name="Lotto :" val={(detail.lotto_id < 0) ? "-" : detail.lotto_id} />
                        <Myrow name="Note :" val={detail.note} />
                    </Grid2>


                    <Grid2 size={4}>
                        <Myrow name="Data Inizio Attività (Verbale/Ordine) :" val={new Date(detail.dt_inizio).toLocaleDateString() || '-'} />
                        <Myrow name="Data chiusura esito :" val={(detail.data_chiusura_esito === null) ? "-" : new Date(detail.data_chiusura_esito).toLocaleDateString()} />
                        <Myrow name="Data Fine Attività (Collaudo/Fornitura) :" val={new Date(detail.dt_fine).toLocaleDateString() || '-'} />
                        <Myrow name="Unità operativa richiedente :" val={detail.uo_richiedente} />
                    </Grid2>

                </Grid2>
                <Divider />

                {detail.allegati.length > 0 && (
                    <Fragment>
                        <Mysection text="allegati" />
                        <Grid2 container spacing={10} rowGap={2}>
                            {detail.allegati.map(o => {
                                return (
                                    <Grid2 key={uuidv4()}>
                                        <Card>
                                            <Typography variant="h6" component="div">
                                                {o.tag}
                                            </Typography>
                                            <CardContent>
                                                {cardDownload(o)}
                                            </CardContent>
                                        </Card>
                                    </Grid2>)
                            })}
                        </Grid2>
                    </Fragment>)}

                {detail.invitati.length > 0 && (<Fragment>
                    <Mysection text="invitati" />
                    <Grid2 container spacing={10} rowGap={2}>
                        {detail.invitati.map(o => {
                            return (
                                <Grid2 key={uuidv4()}>
                                    <Card>
                                        <Chip label={o.ragione_sociale} />
                                        <CardContent>
                                            <p>Partita IVA  <Typography variant="h6" component="span">{o.partita_iva}</Typography></p>
                                            <p>Codice fiscale <Typography variant="h6" component="span">{o.codice_fiscale}</Typography></p>
                                        </CardContent>
                                    </Card>
                                </Grid2>)
                        })}
                    </Grid2>
                </Fragment>)}

                {detail.partecipanti.length > 0 && (
                    <Fragment>
                        <Mysection text="partecipanti" />
                        <Grid2 container spacing={10} rowGap={2}>
                            {detail.partecipanti.map(o => {
                                return (
                                    <Grid2 key={uuidv4()}>
                                        <Card>
                                            <Chip color={o.vincitore === 1 ? 'success' : 'error'} label={o.ragione_sociale} />
                                            <p>Partita IVA  <Typography variant="h6" component="span">{o.partita_iva}</Typography></p>
                                            <p>Codice fiscale <Typography variant="h6" component="span">{o.codice_fiscale}</Typography></p>
                                            <CardContent>
                                                <Stack direction='row' sx={{ alignItems: 'center' }}>
                                                    Ammesso:<Avatar sx={{ bgcolor: o.ammesso === 1 ? green[700] : red[700] }}>{o.ammesso === 1 ? 'Si' : 'No'}</Avatar>
                                                </Stack>
                                                <Stack direction='row' sx={{ alignItems: 'center' }}>
                                                    Aggiudicatario:<Avatar sx={{ bgcolor: o.vincitore === 1 ? green[700] : red[700] }}>{o.vincitore === 1 ? 'Si' : 'No'}</Avatar>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Grid2>)
                            })}
                        </Grid2>
                    </Fragment>
                )}
                {detail.lotti.length > 0 && (
                    <Fragment>
                        <Mysection text="lotti" />
                        <Box sx={{ width: '100%' }}>
                            <Tabs
                                onChange={handleChangeLotto}
                                value={showlotto}
                                aria-label="raccolta lotti">
                                {detail.lotti.map((o) => {
                                    return (
                                        <Tab value={o.gara_lotto_id} label={o.oggetto_appalto} />
                                    );
                                })}
                            </Tabs>
                            {cardLotto}
                        </Box>
                    </Fragment>
                )}

                {detail.gare.length > 0 && (
                    <Fragment>
                        <Mysection text="gare" />
                        <Box sx={{ width: '100%' }}>
                            <Tabs
                                onChange={handleChangeGara}
                                value={showgara}
                                aria-label="raccolta gare">
                                {detail.gare.map((o) => {
                                    return (
                                        <Tab value={o.id} label={o.oggetto_appalto} />
                                    );
                                })}
                            </Tabs>
                            {cardGara}
                        </Box>
                    </Fragment>)}


            </CardContent>
            {showclose === true && (<CardActions>
                <Button size="large" onClick={handleclose}>Chiudi</Button>
            </CardActions>)}
        </Card>
    )
};

        /*
        <Grid2 container spacing={10} rowGap={2}>
                
                    {detail.gare.map( o=>{
                    return(<Grid2  key={uuidv4()}>
                        <Card>
                            <Chip label={"gara "+o.id}/>
                            <p>importo asta {new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(o.importo_base_asta)||'-'}</p>
                            <p>scadenza {o.scadenza_offerta}</p>
                            <CardContent>
                            <Grid2 container spacing={4} rowGap={2}>
                            {o.allegati.map(p=>{
                                return (
                                <Grid2>
                                    <Card>
                                        <Typography variant="h6" component="div">
                                                {p.tag}
                                        </Typography>
                                        <CardContent>
                                            {cardDownload(p)}
                                        </CardContent>
                                    </Card>
                                </Grid2>);
                            })}
                            </Grid2>
                            </CardContent>
                        </Card>
                        </Grid2>)
                })}
                </Grid2>
                */

        /*
        {detail.lotti.map( (o)=>{
                    return(<Grid2 key={uuidv4()}>
                        <Card>
                            <Chip label={"lotto "+o.gara_lotto_id}/>
                            <p>id</p>
                            <Typography variant="h5" component="span">
                                {o.id}
                            </Typography>
                            <p>oggetto</p>
                            <Typography variant="h5" component="p">
                                 {o.oggetto_appalto}
                            </Typography>
                            <p>seduta pubblica aggiudicazione</p>
                            <Typography variant="h5" component="p">
                                 {o.seduta_pubblica_aggiudicazione}
                            </Typography>
                            
                        <CardContent>
                        <Grid2 container spacing={4} rowGap={2}>
                        {o.allegati.map(p=>{
                            return (
                            <Grid2>
                                <Card>
                                    <Typography variant="h6" component="div">
                                            {p.tag}
                                    </Typography>
                                    <CardContent>
                                        {cardDownload(p)}
                                    </CardContent>
                                </Card>
                            </Grid2>);
                        })}
                        </Grid2>
                        </CardContent>
                        </Card>
                    </Grid2>)
                })}
            */
export { EsitiCard };